import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import TwoDatesFormat from '../helpers/TwoDatesFormat'

export default function HeaderSelectedDateData({ selectedParams }) {
  const { dateStart, dateTo, nights } = selectedParams
  return (
    <Fragment>
      {!dateStart || !dateTo ? (
        <FormattedMessage id='any_date' defaultMessage='any date' />
      ) : (
        <Fragment>
          <TwoDatesFormat dateFrom={dateStart} dateTo={dateTo} />
          &nbsp;
          {', '}
          <FormattedMessage
            id='night_info_qty'
            values={{ qty: nights }}
            defaultMessage='{qty, plural, =0 {} one {# night} other {# nights}}'
          />
        </Fragment>
      )}
    </Fragment>
  )
}
